<template>
    <NuxtLayout name="default">
        <div class="flex flex-col w-full">
            <div class="flex flex-col-reverse lg:flex-row w-full mx-auto">
                <div class="hidden lg:block lg:w-1/2 lg:mt-0">
                    <img
                        :alt="$t('auth.alt.default')"
                        class="block max-h-[calc(100vh-1.875rem)] w-full object-cover"
                        src="/images/auth/default.jpg"
                    />
                </div>
                <div class="lg:w-1/2 flex justify-center">
                    <div class="px-6 auth-width">
                        <layout-maintenance class="mt-12 mb-12" />

                        <slot />
                    </div>
                </div>
            </div>

            <layout-footer />
        </div>
    </NuxtLayout>
</template>
